import * as z from "zod"

// The wire shapes the exported module reads from search's own endpoints.
// These are internal to search; consumers see only the member records the
// module maps them to.

export const shortlistListingSchema = z.array(
  z.object({
    id: z.string(),
    name: z.string(),
    class_count: z.number(),
    educator_count: z.number(),
  }),
  "invalid shortlist listing",
)
export type ShortlistListing = z.infer<typeof shortlistListingSchema>

const listingTypeSchema = z.enum(["personal", "team"])

export const classHitSchema = z.object(
  {
    id: z.string(),
    signed_identifier: z.string(),
    class_details: z.object({
      name: z.string(),
      curriculum_key: z.string(),
      subject_key: z.string().nullable(),
      class_size_range: z.object({ gte: z.number(), lte: z.number() }),
    }),
    profile_details: z.object({ name: z.string() }),
    result: z.object({
      subject_id: z.number(),
      timezone_id: z.string(),
      listing_profile: z.object({ listing_type: listingTypeSchema }),
      listed_class_offerings: z.array(
        z.object({ teacher_id: z.string(), teacher_name: z.string() }),
      ),
    }),
  },
  "invalid class hit",
)
export type ClassHit = z.infer<typeof classHitSchema>

export const educatorHitSchema = z.object(
  {
    id: z.string(),
    signed_identifier: z.string(),
    name: z.string(),
    listing_type: listingTypeSchema,
    speciality_attributes: z.array(z.string()),
    tags: z.array(z.string()),
  },
  "invalid educator hit",
)
export type EducatorHit = z.infer<typeof educatorHitSchema>
